<template>
    <div class="news-main-header row">
       <div class="news-search-wrapper col-12 col-md-4 pb-3">
        <p class="news-filter-header">Search by name</p>
        <search-small
          :placeholder="'Search by name'"
          @on-keyup="onSearchTermChanged"
          @on-enter="search"
          ref="newsSearchBox">
        </search-small>
       </div>
       <div class="news-date-picker-wrapper col-12 col-md-3 pb-3">
        <p class="news-filter-header">Date</p>
        <date-picker
          v-model="selectedDate"
          data-vv-validate-on="input"
          :label="'Select time frame'"
          :max-date="currentDate"
          :range="true"/>
       </div>
       <div class="news-category-wrapper col-12 col-md-3 pb-3">
        <p class="news-filter-header">Category</p>
        <div class="category-select">
            <VueSelect
              v-model="selectedCategory"
              :options="categories"
              placeholder="Select an option"
              @update:model-value="onCategoryChanged"
            />
        </div>
       </div>
       <div class="buttons-wrapper col-12 col-md-2 pb-3">
        <div class="search-button-wrapper">
          <div 
            class="homebase-btn-primary mt-4 ml-md-4" 
            @click="search">
            Search
          </div>
        </div>
        <div class="reset-button-wrapper">
          <a @click="reset">Clear</a>
        </div>
       </div>
    </div>
</template>
<script>

import api from "@/api";
import moment from "moment";
import 'vue3-select-component/styles'
import VueSelect from "vue3-select-component";
import DatePicker from "@/components/homebase/DatePicker";
import SearchSmall from "@/components/homebase/SearchSmall";

export default {
    name: "news-feed-filters",
    components: {
        VueSelect,
        DatePicker,
        SearchSmall
    },
    created() {
      this.initializeNewsFilters();
    },
    data() {
        return {
          categories: [],
          textFilterValue: null,
          categoryFilterValue: null,
          selectedDate: null,
          selectedCategory: null,
          currentDate: null
        }
    },
    methods: {
      async initializeNewsFilters() {
        this.setCurrentDate();
        await this.setCategories();
      },
      setCurrentDate() {
        const dateStrFormat = "YYYY-MM-DD";
        this.currentDate = moment().format(dateStrFormat);
      },
      async setCategories() {
        let categoriesResponse = await api.getNewsCategories();
        categoriesResponse.data.data.newsCategories.forEach((category, index) => {
          this.categories.push({ value: index + 1, label: category });
        });
      },
      onSearchTermChanged(payload) {
        this.textFilterValue = payload.length > 0 ? payload : null;
      },
      onCategoryChanged() {
        this.categoryFilterValue = (this.selectedCategory) ? this.categories.filter(c => c.value === this.selectedCategory)[0].label : null;
      },
      search() {
        var filtersObject = { 
          name: this.textFilterValue, 
          startDate: this.selectedDate ? this.selectedDate.start : null, 
          endDate: this.selectedDate ? this.selectedDate.end : null,
          category: this.categoryFilterValue 
        };

        if(!this.isEmptyObject(filtersObject)) {
          this.$parent.$emit("onFilteredSearch", filtersObject);
        }
        else {
          this.$parent.$emit("onResetFilters");
        }
      },
      reset() {
        this.$parent.$emit("onResetFilters");
      },
      isEmptyObject(obj) {
        return Object.values(obj).every(val => !val);   
      }
    }
}
</script>
<style scoped>
.news-main-header {
  display: flex;
}
.news-filter-header {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.news-search-wrapper {
  width: 45%;
  padding-bottom: 36px;
}
.news-search-wrapper > div { 
  max-width: 100% !important;
}
.news-date-picker-wrapper {
  width: 45%;
}
.news-search-wrapper :deep(.aone-table-search-input) {
  font-size: 15px;
}
.category-select {
  --vs-border-radius: 13px;
  --vs-border: 1px solid #888888;
  --vs-min-height: 42px;
  --vs-padding: 0 12px;
  --vs-font-size: 14px;
  --vs-option-font-size: 14px;
  --vs-placeholder-color: #ccc;
  --vs-option-focused-background-color: rgba(0, 0, 0, 0.03);
  --vs-option-selected-background-color: none
  font-size: 14px;
}

.category-select :deep(.input-placeholder),
.category-select :deep(.single-value),
.category-select :deep(input) {
  font-size: 14px !important;
}

.news-date-picker-wrapper :deep(.dp__input) {
  height: 42px;
  border-radius: 13px;
}
.buttons-wrapper {
  display: flex;
  gap: 25px;
}
.reset-button-wrapper  {
  min-width: 22px;
}
.reset-button-wrapper > a {
  font-family: artifaktElementBold;
  text-decoration: underline;
  font-size: 16px;
  line-height: 80px;
  max-height: 80px;
  text-align: center !important;
  cursor: pointer;  
}
.search-button-wrapper :deep(.homebase-btn-primary) {
  min-width: 130px !important;
}
@media (min-width: 576px) {
  .reset-button-wrapper {
    padding-top: 16px;
  }
}
@media (min-width: 768px) {
  .search-button-wrapper {
    margin-top: 11px;
  }
}
@media (max-width: 768px) {
  .reset-button-wrapper {
    padding-top: 5px;
  }
}
</style>